import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import IconButton from '@material-ui/core/IconButton'
import MoreHoriz from '@material-ui/icons/MoreHoriz'

const styles = () => ({
  root: {
    height: 20,
    display: 'flex',
    alignItems: 'center',
  },
  button: {
    width: 40,
    height: 40,
  },
  icon: {
    fontSize: 28,
  },
  menuItem: {
    textTransform: 'none',
  },
})

class ExpandTableBox extends React.PureComponent {
  state = {
    anchorEl: null,
    menuOpen: false,
  };

  handleIconClick = (event) => {
    event.stopPropagation()
    this.setState({ menuOpen: true, anchorEl: event.currentTarget })
  };

  handleMenuClose = () => {
    this.setState({ menuOpen: false })
  };

  handleMenuSelect = (event) => {
    this.handleMenuClose()
    this.props.onSelect(event)
  };

  render() {
    const { menuOpen, anchorEl } = this.state
    const { classes, text } = this.props

    return (
      <div className={classes.root}>
        <IconButton
          color="primary"
          className={classes.button}
          onClick={this.handleIconClick}
          aria-label="View admin options">
          <MoreHoriz className={classes.icon} />
        </IconButton>
        <Menu
          open={menuOpen}
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={this.handleMenuClose}>
          <MenuItem
            classes={{ root: classes.menuItem }}
            onClick={this.handleMenuSelect}>
            {text}
          </MenuItem>
        </Menu>
      </div>
    )
  }
}

ExpandTableBox.propTypes = {
  text: PropTypes.string,
  onSelect: PropTypes.func,
  classes: PropTypes.object,
}

export default withStyles(styles)(ExpandTableBox)



// WEBPACK FOOTER //
// ./src/components/molecules/ExpandTableBox.js